<template>
  <transition name="fade">
    <van-overlay :show="isShow" :z-index="zIndex" :lock-scroll="false" @click.self="onMask">
      <div class="wrapper" @click.stop>
        <transition name="slide-fade">
          <div v-show="isShow" :class="isInput ? 'hale-content-min' : 'half-content'">
            <div class="half-title">
              <i class="icon-v3_outline_close" @click.self="onMask" />
              <span>{{ title }}</span>
            </div>
            <slot name="content"></slot>
          </div>
        </transition>
      </div>
    </van-overlay>
  </transition>
</template>

<script>
import Vue from 'vue'
import { Overlay } from 'vant'
import { stopScroll, openScroll } from './util'

Vue.use(Overlay)

export default {
  name: 'VantPopupMember',
  props: {
    zIndex: {
      type: String,
      default: '100',
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    isInput: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isShow: {
      handler(val) {
        if (val) {
          // 开启弹窗，禁止底部滚动
          stopScroll()
        } else {
          // 关闭弹窗，可以滚动
          openScroll()
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    // 组件销毁，可以滚动
    openScroll()
  },
  methods: {
    onMask() {
      this.$emit('clickMask')
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter,
.fade-leave-active {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.1s ease;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(100%);
  transition: all 0.3s ease;
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
}
.half-content {
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  max-height: 90%;
  background: #fff;
  border-radius: 64px 64px 0 0;
  z-index: 10;
  padding: 104px 40px 40px 40px;
  display: flex;
  flex-direction: column;
}
.hale-content-min {
  height: 516px;
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #fff;
  border-radius: 24px 24px 0 0;
  z-index: 10;
  padding: 48px 40px;
}
.half-title {
  font-family: 'Aspira Medium';
  font-size: 36px;
  text-align: center;
  line-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    position: absolute;
    left: 40px;
    font-size: 40px;
    top: 40px;
  }
  span {
    margin-left: 60px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
